import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Subject }    from 'rxjs';
import { KeycloakService } from '../login/keycloak.service';
import { saveAs } from 'file-saver';
import { GlobalsService } from '../_services/globals.service';
import { catchError } from 'rxjs/operators';


@Injectable()
export class TabledataService 
{

   private onBeginDownloadData:Subject<any>;
   private $onBeginDownloadData:Observable<any>; 
    
   private onDoneDownloadData:Subject<any>;
   private $onDoneDownloadData:Observable<any>; 

   private sFeaturesData:Subject<any>;
   private $sFeaturesDataObservable:Observable<any>;
   private sRowSelect:Subject<any>; 
   private sRowUnselect:Subject<any>;
   private $sRowSelectObservable:Observable<any>;
   private $sRowUnselectObservable:Observable<any>;
   private sSelectItem:Subject<any>; 
   private $SelectItemObservable:Observable<any>;
   
   private sShowTable:Subject<any>; 
   private $ShowTableObservable:Observable<any>;

   private sCountVisibleTables:Subject<any>; 
   private $CountVisibleTablesObservable:Observable<any>;

   private sRequestTableData:Subject<any>; 
   private $RequestTableData:Observable<any>; 

   private columnLabels: Record<string, string> = {};


  constructor(private http: HttpClient , private kks:KeycloakService ,private gs:GlobalsService  ) 
  { 
      this.onBeginDownloadData = new Subject<any>();
      this.onDoneDownloadData = new Subject<any>();
      
      this.$onBeginDownloadData = this.onBeginDownloadData.asObservable();
      this.$onDoneDownloadData = this.onDoneDownloadData.asObservable();
      
      this.sFeaturesData = new Subject<any>();
    
      this.sRowSelect= new Subject<any>();
      this.sRowUnselect= new Subject<any>();
      this.sSelectItem = new Subject<any>(); 
      
      this.$sFeaturesDataObservable = this.sFeaturesData.asObservable();
     
      this.$sRowSelectObservable = this.sRowSelect.asObservable();
      this.$sRowUnselectObservable = this.sRowUnselect.asObservable();
      this.$SelectItemObservable = this.sSelectItem.asObservable(); 
      
      this.sShowTable = new Subject<any>();
      this.$ShowTableObservable = this.sShowTable.asObservable(); 
      
      this.sCountVisibleTables = new Subject<any>();
      this.$CountVisibleTablesObservable = this.sCountVisibleTables.asObservable();
      
      
      this.sRequestTableData= new Subject<any>();
      this. $RequestTableData = this.sRequestTableData.asObservable();
  }

  
  public  setOnBeginDownloadData(tag:any)
  {
      this.onBeginDownloadData.next(tag);
  }
  
  public subscribeOnBeginDownloadData():Observable<any>
  {
      return this.$onBeginDownloadData;
  }
  
  public  setOnDoneDownloadData( data: any[] | null )
  {
      this.onDoneDownloadData.next(data);
  }
  
  public subscribeOnDoneDownloadData():Observable<any>
  {
      return this.$onDoneDownloadData;
  }
  
  
  public  setRequestTableData(node:any )
  {
      this.sRequestTableData.next(node);
  }
  
  public subscribeRequestTableData():Observable<any>
  {
      return this.$RequestTableData;
  }
  
  public  setCountVisibleTable(cnt:number )
  {
      this.sCountVisibleTables.next(cnt);
  }
  
  public subscribeCountVisibleTableListener():Observable<any>
  {
      return this.$CountVisibleTablesObservable;
  }
  
  
  public  setShowTable(id:any , show:boolean , label:string , node:any)
  {
      this.sShowTable.next({id:id,visible:show,label:label, node});
  }
  
  public subscribeTableShowListener():Observable<any>
  {
      return this.$ShowTableObservable;
  }
  
  public  setTableData(data:any)
  {
      this.sFeaturesData.next(data);
  }
  
  public subscribeDataListener():Observable<any>
  {
      return this.$sFeaturesDataObservable;
  }
  
  
  public  setTableRowSelection(data:any)
  {
      this.sRowSelect.next(data);
  }
  
  public subscribeTableRowSelectionListener():Observable<any>
  {
      return this.$sRowSelectObservable;
  }
  
  public  setTableRowUnSelection(data:any)
  {
      this.sRowUnselect.next(data);
  }
  
  public subscribeTableRowUnSelectionListener():Observable<any>
  {
      return this.$sRowUnselectObservable;
  }
  
  public  setSelectItemData(removed:boolean, data:any)
  {
      this.sSelectItem.next({data:data,removed:removed});
  }
  
  public subscribeSelectItemDataListener():Observable<any>
  {
      return this.$SelectItemObservable;
  }
  
  
  
  public getFile(url: string, auth: boolean = false, filename?: string): void {
    const fn = filename ?? 'download.pdf';

    if (!auth) {
        this.http.get(url, { responseType: 'blob' }).subscribe({
        next: (blob) => this.downloadFile(blob, fn),
        error: (e) => console.log(e)
        });
        return;
    }

    this.http.get(url, {
        withCredentials: false,
        responseType: 'blob'
    }).subscribe({
        next: (blob) => this.downloadFile(blob, fn),
        error: (e) => console.log(e)
    });
  }
  
  public deleteFile(url: string, auth: boolean = false): Observable<any> {
    if (!auth) {
        return this.http.delete<any>(url);
    }

    return this.http.delete<any>(url, { withCredentials: false });
  }
  
  public getCsv(url: string, auth: boolean = false, name: string): void {
    if (!auth) {
        this.http.get(url, { responseType: 'text' }).subscribe({
        next: (text) => this.downloadCsv(text, name),
        error: (e) => console.log(e)
        });
        return;
    }

    this.http.get(url, {
        withCredentials: false,
        responseType: 'text'
    }).subscribe({
        next: (text) => this.downloadCsv(text, name),
        error: (e) => console.log(e)
    });
  }
  
  private downloadCsv(csvText: string, fn: string): void {
    const BOM = '\uFEFF'; // Excel-friendly UTF-8 BOM
    const blob = new Blob([BOM + (csvText ?? '')], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, fn);
  }
  
  private downloadFile(blob: Blob, fn: string): void {
    saveAs(blob, fn);
  }
  
  
  
  public getData(url: string, auth: boolean = false): Observable<any> {
    return this.http.get<any>(url, {
        withCredentials: false
    });
  }
  
  public addNewData(url: string, body: string): Observable<any> {
    console.log('FOTOVOLTAJKA USER ID', KeycloakService.auth?.authz?.subject);

    const payload = body ? JSON.parse(body) : {};

    return this.http.post<any>(url, payload).pipe(
        catchError((error) => throwError(() => error))
    );
  }
  
  public editData(url: string, body: string): Observable<any> {

    const payload = body ? JSON.parse(body) : {};

    return this.http.put<any>(url, payload).pipe(
        catchError(err => throwError(() => err))
    );
    }

  public deleteData(url: string): Observable<any> {

    return this.http.delete<any>(url).pipe(
        catchError(err => throwError(() => err))
    );
    }
  

  public getDocumentTypesFromBackend(obMid: number): Observable<any> {
    const url = this.gs.getRestUrl() + "/api/documents/types?ob_mid=" + encodeURIComponent(String(obMid));
    return this.getData(url, true);
  }
  
  
  public getDocumentTypes() {
    const sub = ['PZI', 'PID', 'DZO', 'FIN DOK', 'POŽARNI NAČRT', 'RAZNO']
        .map(l => ({ label: l, value: l }));

    return [
        { label: 'SPLOŠNO', value: 'SPLOŠNO' },
        { label: 'EOL', value: 'EOL', children: sub },
        { label: 'SE', value: 'SE', children: sub },
    ];
  }
  
  createDocumentType(payload: { obMid: number; parentId: number | null; label: string }) {
    return this.http.post(
        this.gs.getRestUrl() + '/api/documents/type/create',
        payload,
        { responseType: 'json' }
    );
  }

  renameDocumentType(payload: { id: number; obMid: number; label: string }) {
    return this.http.post(
        this.gs.getRestUrl() + '/api/documents/type/rename',
        payload,
        { responseType: 'json' }
    );
  }

  public setColumnLabel(field: string, label: string): void {
      this.columnLabels[field] = label;
  }

  public getColumnLabel(field: string): string | null {
      const direct = this.columnLabels[field];
      if (direct) return direct;

      if (field.startsWith('_')) {
          return this.columnLabels[field.substring(1)] || null;
      }

      return null;
  }

}
